import "./IndexAnon.scss";

document.addEventListener("DOMContentLoaded",
                          () => {
                              bindElements();
                              attachEvents();
                          });

let searchForm: HTMLFormElement;
let searchSubmitButton: HTMLInputElement;
let page: HTMLInputElement;
let prevPageButton: HTMLButtonElement;
let nextPageButton: HTMLButtonElement;

let adultCategoryButtons: HTMLCollectionOf<Element>;
let childrenCategoryButtons: HTMLCollectionOf<Element>;

function bindElements() {
    searchForm = document.getElementById("search-form") as HTMLFormElement;
    searchSubmitButton = document.getElementById("search") as HTMLInputElement;
    page = document.getElementById("page") as HTMLInputElement;
    prevPageButton = document.getElementById("prev-page") as HTMLButtonElement;
    nextPageButton = document.getElementById("next-page") as HTMLButtonElement;

    adultCategoryButtons = document.getElementsByClassName("adult-category") as HTMLCollectionOf<Element>;
    childrenCategoryButtons = document.getElementsByClassName("childrens-category") as HTMLCollectionOf<Element>;
}

function setCategory(bookId: string, category: string) {
    let loader = document.getElementById(`book-loader-${bookId}`) as HTMLElement;

    loader.style.display = "block";

    fetch(`/books/${bookId}/add-category/` + category, {
                                                      method: 'post',
                                                      credentials: "same-origin"
                                                  }).then((data: Response) => {

        loader.style.display = "none";

        let buttonContainer = document.getElementById(`book-set-category-${bookId}`) as HTMLElement;

        buttonContainer.style.display = "none";

        let noCategoriesSpan = document.getElementById(`book-no-categories-${bookId}`) as HTMLElement;

        let hasExisting = true;
        if (noCategoriesSpan){
            noCategoriesSpan.style.display = "none";
            hasExisting = false;
        }

        let categoriesParagraph = document.getElementById(`book-categories-${bookId}`) as HTMLParagraphElement;

        let categoryLink = document.createElement('a') as HTMLAnchorElement;
        categoryLink.href = "?tag=" + category;
        categoryLink.text = category;

        if (hasExisting){
            let textNode = document.createTextNode(",");

            categoriesParagraph.appendChild(textNode);

            categoryLink.text = " " + categoryLink.text;
        }

        categoriesParagraph.appendChild(categoryLink);
    });
}

function attachEvents() {
    if (prevPageButton != null) {
        prevPageButton.addEventListener("click", goToPreviousPage);
    }

    if (nextPageButton != null) {
        nextPageButton.addEventListener("click", goToNextPage);
    }

    if (searchSubmitButton != null) {
        searchSubmitButton.addEventListener("click", search);
    }

    console.log(adultCategoryButtons);
    console.log(childrenCategoryButtons);

    if (adultCategoryButtons != null && adultCategoryButtons.length > 0){
      for (let i = 0; i < adultCategoryButtons.length; i++){
          let button = adultCategoryButtons.item(i);

          button.addEventListener("click", e => {
              let element = e.target as HTMLElement;

              let bookId = element.getAttribute("data-book-id").valueOf();

              setCategory(bookId, "AD");
          })
      }
    }

    if (childrenCategoryButtons != null && childrenCategoryButtons.length > 0){
        for (let i = 0; i < childrenCategoryButtons.length; i++){
            let button = childrenCategoryButtons.item(i);

            button.addEventListener("click", e => {
                let element = e.target as HTMLElement;

                let bookId = element.getAttribute("data-book-id").valueOf();

                setCategory(bookId, "CH");
            })
        }
    }
}

function goToPreviousPage() {
    page.value = String(getCurrentPage() - 1);
    searchForm.submit();
}

function goToNextPage() {
    page.value = String(getCurrentPage() + 1);
    searchForm.submit();
}

let getCurrentPage = () => parseInt(page.value);

function search() {
    page.value = "1";
}
